import useSlider from "./Slider.hook";

export default useSlider;
